import { render, staticRenderFns } from "./CarrierMasterDataForm.vue?vue&type=template&id=a04d0e92&scoped=true"
import script from "./CarrierMasterDataForm.vue?vue&type=script&lang=js"
export * from "./CarrierMasterDataForm.vue?vue&type=script&lang=js"
import style0 from "./CarrierMasterDataForm.vue?vue&type=style&index=0&id=a04d0e92&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a04d0e92",
  null
  
)

export default component.exports